import { render, staticRenderFns } from "./update_actions.vue?vue&type=template&id=85088c4e&scoped=true&"
import script from "./update_actions.vue?vue&type=script&lang=js&"
export * from "./update_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85088c4e",
  null
  
)

export default component.exports